import React, { useState, useEffect } from 'react';
import { getCampaignEndDate } from '../../util/promoPrintempsRoboupClient';
import css from './PrintempsRoboupPromo.module.css';

const pad = n => String(n).padStart(2, '0');

const CountdownTimer = ({ expiredLabel = 'Offre terminée' }) => {
  const [remaining, setRemaining] = useState(() => {
    const diff = getCampaignEndDate().getTime() - Date.now();
    return Math.max(0, diff);
  });

  useEffect(() => {
    if (remaining <= 0) return;
    const id = setInterval(() => {
      const diff = getCampaignEndDate().getTime() - Date.now();
      setRemaining(Math.max(0, diff));
    }, 1000);
    return () => clearInterval(id);
  }, [remaining > 0]);

  if (remaining <= 0) {
    return <span className={css.countdownExpired}>{expiredLabel}</span>;
  }

  const totalSec = Math.floor(remaining / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;

  return (
    <div className={css.countdown}>
      <div className={css.countdownBlock}>
        <span className={css.countdownDigits}>{pad(h)}</span>
        <span className={css.countdownLabel}>h</span>
      </div>
      <span className={css.countdownSeparator}>:</span>
      <div className={css.countdownBlock}>
        <span className={css.countdownDigits}>{pad(m)}</span>
        <span className={css.countdownLabel}>min</span>
      </div>
      <span className={css.countdownSeparator}>:</span>
      <div className={css.countdownBlock}>
        <span className={css.countdownDigits}>{pad(s)}</span>
        <span className={css.countdownLabel}>sec</span>
      </div>
    </div>
  );
};

export default CountdownTimer;
